import { EventEmitter, Injectable } from '@angular/core';
import { v4 } from '../Common/Helpers/v4';

@Injectable()
export class PageLoadHandler {
	public event = new EventEmitter();
	private reqeustQueue: Array<string> = [];

	public pending(emitEvent: boolean | number) {
		const requestID = v4();

		if (emitEvent) {
			this.reqeustQueue.push(requestID);

			const TimeOut = window.setTimeout(() => this.event.emit('show'), typeof emitEvent === 'boolean' ? 300 : emitEvent);

			return {
				id: requestID,
				timeOut: TimeOut,
			};
		}

		return false;
	}

	public resolve(request: { id: string; timeOut: number }) {
		const index = this.reqeustQueue.indexOf(request.id);
		this.reqeustQueue.splice(index, 1);
		clearTimeout(request.timeOut);

		if (this.reqeustQueue.length === 0) {
			this.event.emit('hide');
		}
	}
}
